import React, { useState } from "react";
import Select from "react-select";
import Slider from 'rc-slider';
import 'rc-slider/assets/index.css'; // For styling sliders
import { toast } from "react-toastify";
import 'react-toastify/dist/ReactToastify.css'; // For toast notifications
import { useNavigate } from "react-router-dom";

const LeaveFilter = ({ setBillMonth, setConsumer, setBucket, setLrValue, setSanctionedValue, setNetBill, consumerList, consumerListLen }) => {

  const [lrValue, setLocalLrValue] = useState([0, 100]);
  const [sanctionedValue, setLocalSanctionedValue] = useState([0, 15346]);
  const [netBill, setLocalNetBill] = useState([200, 58613555]);

  const navigate = useNavigate();

  const toastContent = "Reminder has been sent!";

  const billMonthOptions = [
    { value: 6, label: "July 2024" },
    { value: 7, label: "August 2024" },
    { value: 8, label: "September 2024" },
  ];

  const consumerOptions = [
    { value: "DS", label: "DS" },
    { value: "NDS", label: "NDS" },
    { value: "LT", label: "LT" },
    { value: "AGRI", label: "AGRI" },
  ];

  const bucketOptions = [
    { value: [0, 1], label: "ALL" },
    { value: [0.3, 0.7], label: "Maybe(30-70)" },
    { value: [0, 0.3], label: "No(0-30)" },
    { value: [0.7, 1], label: "Yes(70-100)" },
  ];

  const showReport = () => {
    toast.error(toastContent);
    navigate("/call-to-action-report", {state:{consumerList:consumerList}})
  };

  const customStyles = {
    option: (provided, state) => ({
      ...provided,
      backgroundColor: state.isFocused ? "#ff9b44" : "#fff",
      color: state.isFocused ? "#fff" : "#000",
      "&:hover": {
        backgroundColor: "#ff9b44",
      },
    }),
    control: (provided) => ({
      ...provided,
      borderColor: "#ff9b44", // Custom border color
      boxShadow: "none",
      "&:hover": {
        borderColor: "#ff9b44", // Focus border color
      },
    }),
  };

  // Handle multi-select change for consumers
  const handleConsumerChange = (selectedOptions) => {
    const selectedValues = selectedOptions ? selectedOptions.map(option => option.value) : [];
    setConsumer(selectedValues);
  };

  // Handle single-select change for prediction bucket
  const handleBucketChange = (option) => {
    setBucket([option.value]); // Set the value to a single bucket value
  };

  return (
    <div>
      {/* Search Filter */}
      <div className="row filter-row">
        {/* Bill Month Filter */}
        <div className="col-sm-6 col-md-3 col-lg-3 col-xl-3 col-12">
          <div className="input-block mb-3 form-focus select-focus">
            <Select
              options={billMonthOptions}
              onChange={(option) => setBillMonth([option.value])}
              placeholder="July 2024"
              styles={customStyles}
            />
          </div>
          <div className="input-block mb-3 form-focus select-focus">
            <Select
              options={bucketOptions} // Single select now
              onChange={handleBucketChange}
              placeholder="Prediction Bucket"
              styles={customStyles}
            />
          </div>
          {/* Consumer Multi-Select Filter */}
          <div className="input-block mb-3 form-focus select-focus">
            <Select
              isMulti
              options={consumerOptions}
              onChange={handleConsumerChange}
              placeholder="Consumers - ALL"
              styles={customStyles}
            />
          </div>
        </div>

        {/* Prediction Bucket Single-Select Filter */}

        {/* LR Prediction Values in Card */}
        {/* <div className="col-sm-6 col-md-3 col-lg-3 col-xl-2 col-12">
          <div className="mb-3">
            <div className="card">
              <div className="card-body">
                <p>LR Prediction Values</p>
                <Slider
                  min={0}
                  max={100}
                  step={2}
                  value={lrValue}
                  onChange={(values) => {
                    setLocalLrValue(values);
                    setLrValue(values);
                  }}
                  range
                />
                <span>{lrValue[0]} to {lrValue[1]}</span>
              </div>
            </div>
          </div>
        </div> */}

        {/* Sanctioned Load in Card */}
        <div className="col-sm-6 col-md-3 col-lg-3 col-xl-3 col-12">
          <div className="mb-3">
            <div className="card" style={{height:"165px"}}>
              <div className="card-body">
                <p>Sanctioned Load</p>
                <Slider
                  min={0}
                  max={15346}
                  step={2}
                  value={sanctionedValue}
                  onChange={(values) => {
                    setLocalSanctionedValue(values);
                    setSanctionedValue(values);
                  }}
                  range
                />
                <span>{sanctionedValue[0]} to {sanctionedValue[1]}</span>
              </div>
            </div>
          </div>
        </div>

        {/* Net Bill in Card */}
        <div className="col-sm-6 col-md-3 col-lg-3 col-xl-3 col-12">
          <div className="mb-3">
            <div className="card" style={{height:"165px"}}>
              <div className="card-body">
                <p>Net Bill</p>
                <Slider
                  min={200}
                  max={58613555}
                  step={2}
                  value={netBill}
                  onChange={(values) => {
                    setLocalNetBill(values);
                    setNetBill(values);
                  }}
                  range
                />
                <span>{netBill[0]} to {netBill[1]}</span>
              </div>
            </div>
          </div>
        </div>

        {/* Reminder Button in Card */}
        <div className="col-sm-6 col-md-3 col-lg-3 col-xl-3 col-12">
          <div className="mb-3">
            <div className="card">
              <div className="card-body">
                <h5>No Of Consumers</h5>
                <br></br>
                <h3>{consumerListLen}</h3>
                <br></br>
                <button className="outline-btn" onClick={showReport}>Send Reminder</button>

              </div>
            </div>
          </div>
        </div>
        {/* {console.log("consumerListconsumerList", consumerList)} */}
      </div>
      <hr></hr>
    </div>
  );
};

export default LeaveFilter;
